import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import styles from "./RoundMultiplierPop.module.scss";
// import { decrypt } from "../../../helper/secretManager";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { gameSlice } from "../../../lib/store/game/slice";

// import hexActive from "../../../assets/images/hexActive.svg";
import hexWrong from "../../../assets/images/hexWrong.svg";
import hexRight from "../../../assets/images/hexRight.svg";
import hexDef from "../../../assets/images/hexDef.svg";
import rightHex from "../../../assets/images/rightHex.svg";
import leftHex from "../../../assets/images/leftHex.svg";
import hexfade from "../../../assets/images/hexFade.svg";
import hexJackpot from "../../../assets/images/jackpotBorder.png";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";
// import { socket } from "../../../utils/socket";

const RoundMultiplierPop = ({ show, onHide, data }) => {
  // const { t } = useTranslation();
  const t = useLanguage();

  const onCloseHandler = () => {
    onHide();
  };
  return (
    <>
      <Modal
        show={show}
        onHide={() => onCloseHandler()}
        backdrop="true"
        centered
        scrollable="true"
        className={`${styles.gameHistoryDetail} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={() => onCloseHandler()}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
               <div className="text-center pt-4">
            <h5 className="m-0 themeClr2 fw-bold" style={{fontSize : 20, lineHeight: "30px"}}>Round Multiplier Details</h5>
          </div>

            <div
              className="mx-auto pt-4 allow-scroll"
              style={{
                maxWidth: 292,
                maxHeight: "calc(100vh - 230px)",
                overflowY: "auto",
                fontSize: "15px", 
                lineHeight: "2.0", 
              }}
            >
              <ul className="list-unstyled ps-0 mb-0">
                <li
                  className="text-white py-2 my-2 d-flex justify-content-between gap-10"
                  style={{ borderBottom: "1px dashed #313131" }}
                >
                  <span>Round Type :</span>
                  <span>{data.roundType}</span>
                </li>
                <li
                  className="text-white py-2 my-2 d-flex justify-content-between gap-10"
                  style={{ borderBottom: "1px dashed #313131" }}
                >
                  <span>BTNC Reward :</span>
                  <span>{data.btncRewardReceived}</span>
                </li>
                <li
                  className="text-white py-2 my-2 d-flex justify-content-between gap-10"
                  style={{ borderBottom: "1px dashed #313131" }}
                >
                  <span>Coin Reward :</span>
                  <span>{data.coinRewardReceived}</span>
                </li>
                <li
                  className="text-white py-2 my-2 d-flex justify-content-between gap-10"
                  style={{ borderBottom: "1px dashed #313131" }}
                >
                  <span>Energy Spent :</span>
                  <span>{data.energySpent}</span>
                </li>
                <li
                  className="text-white py-2 my-2 d-flex justify-content-between gap-10"
                  style={{ borderBottom: "1px dashed #313131" }}
                >
                  <span>Jackpot Reward :</span>
                  <span>{data.jackpotRewardReceived}</span>
                </li>
                <li
                  className="text-white py-2 my-2 d-flex justify-content-between gap-10"
                  style={{ borderBottom: "1px dashed #313131" }}
                >
                  <span>Leaderboard Point :</span>
                  <span>{data.leaderboardPointsEarned}</span>
                </li>
                <li
                  className="text-white py-2 my-2"
                  style={{ borderBottom: "1px dashed #313131" }}
                >
                  <span className="fw-sbold d-block">Description : </span>
                  <span className="d-block mt-2" style={{ color: "#878787" }}>
                    {data.shortDescription}
                  </span>
                </li>
              </ul>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default RoundMultiplierPop;

const jackpotShadow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="71"
    height="80"
    viewBox="0 0 71 80"
    fill="none"
  >
    <g filter="url(#filter0_f_7_689)">
      <path
        d="M35.7512 5.18576L35.2805 4.9137L34.8099 5.18576L5.52934 22.1111L5.05952 22.3827V22.9254V56.7762V57.3188L5.52934 57.5904L34.8099 74.5158L35.2805 74.7878L35.7512 74.5158L65.0317 57.5904L65.5016 57.3188V56.7762V22.9254V22.3827L65.0317 22.1111L35.7512 5.18576Z"
        stroke="#FFE898"
        stroke-width="1.88096"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_7_689"
        x="0.357217"
        y="0.0652246"
        width="69.8461"
        height="79.5707"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.88096"
          result="effect1_foregroundBlur_7_689"
        />
      </filter>
    </defs>
  </svg>
);
